import moment from "moment"

export const RE_DIGIT = new RegExp(/^\d+$/)

export const isNumeric = (evt) => {
  const regex = /[^0-9]|\./
  if (regex.test(evt)) {
    return false
  }
  return true
}

export const getCurrentTimeUnix = () => {
  return moment().unix()
}

export const validateForm = data => data ? Object.values(data).every(value => value && value?.toString().trim() !== "") : false;

export const validatePin = (form) => {
  if (form.pin.length !== 6 || form.confirm_pin.length !== 6) {
    return {
      valid: false,
      message: 'PIN Harus Berisi 6 Digit Angka'
    };
  }

  if (form.pin !== form.confirm_pin) {
    return {
      valid: false,
      message: 'PIN dan Konfirmasi PIN Tidak Cocok'
    };
  }

  return {
    valid: true,
    message: null
  };
}

export const validateInputPin = (value) => value && value.length > 0 && value.length > 6

export const validatePassword = (form) => {
  if (form.new_password !== form.confirm_password) {
    return {
      valid: false,
      message: 'Password baru tidak cocok!'
    };
  }

  return {
    valid: true,
    message: null
  };
}

export const validateInputPassword = ({
  name, value, form
}) => {
  if (["new_password", "confirm_password"].includes(name) && value && value.length < 6) {
    return {
      error: true,
      message: 'Password minimal berisi 6 karakter!'
    }
  }
  if (name === 'confirm_password' && value && value !== form.new_password) {
    return {
      error: true,
      message: 'Password tidak sama!'
    }
  }
  return {
    error: false,
    message: ''
  }
}